import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description: string;
  children?: ReactNode;
}

export default function PageHeader({ title, description, children }: PageHeaderProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-gradient-to-r from-primary-50 to-background-50 p-6 md:p-8">
      <h1 className="text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
        {description}
      </p>
      {children ? <div className="mt-5">{children}</div> : null}
    </div>
  );
}